const TrackerbaseAuthCallbackViewModuleConstants = Object.freeze({
    rootStateName: "authCallback",
    prevStateLabel: null,
    stateUrl: "auth-callback"
});

export default TrackerbaseAuthCallbackViewModuleConstants;



//////////////////
// WEBPACK FOOTER
// ./src/views/auth-callback/Constants.js
// module id = MaG8
// module chunks = 1